import React from 'react';

const EditPodOverview = ({podDetail, setPodDetail}) => {

    const handleDetailChanges = (event) => {
        const {name, value, type} = event.target;
        const existingPodDetail = {...podDetail};

        if (type === 'checkbox') {
            existingPodDetail[name] = !existingPodDetail[name];
        } else {
            existingPodDetail[name] = value;
        }

        setPodDetail(existingPodDetail);
    }

    return (
        <>
            <div className="flex justify-start w-full">

                <div className="field-group-container">

                    <div className="field-container w-full">
                        <div className="field-label">
                            Name
                        </div>
                        <input
                            type="text"
                            className="input-field-max w-full"
                            id="name"
                            name="name"
                            value={podDetail?.name}
                            onChange={handleDetailChanges}>
                        </input>
                    </div>

                    <div className="field-container w-full">
                        <div className="field-label">
                            Display Label
                        </div>
                        <input
                            type="text"
                            className="input-field-max w-full"
                            id="displayLabel"
                            name="displayLabel"
                            value={podDetail?.displayLabel}
                            onChange={handleDetailChanges}>
                        </input>
                    </div>

                    <div className="field-container w-full">
                        <div className="field-label">
                            Description
                        </div>
                        <textarea
                            className="input-field-max w-full"
                            id="description"
                            name="description"
                            value={podDetail?.description}
                            onChange={handleDetailChanges}/>
                    </div>

                    <div className="field-container w-full">
                        <div className="field-label">
                            Link
                        </div>
                        <input
                            type="text"
                            className="input-field-max w-full"
                            id="link"
                            name="link"
                            value={podDetail?.link}
                            onChange={handleDetailChanges}>
                        </input>
                    </div>

                    <div className="field-container w-full">
                        <div className="field-label">
                            Product Template Link
                        </div>
                        <input
                            type="text"
                            className="input-field-max w-full"
                            id="templateLink"
                            name="templateLink"
                            value={podDetail?.templateLink}
                            onChange={handleDetailChanges}>
                        </input>
                    </div>

                </div>

                <div className="w-full px-4">
                    <div className="flex justify-start">
                        <div className="field-group-container">

                            <div className="field-container w-full justify-start flex mt-8">
                                <input
                                    type="checkbox"
                                    className="h-6 w-6 mr-1"
                                    id="ignoreProductTypeInDesignName"
                                    name="ignoreProductTypeInDesignName"
                                    value={podDetail?.ignoreProductTypeInDesignName}
                                    checked={podDetail?.ignoreProductTypeInDesignName}
                                    onChange={handleDetailChanges}>
                                </input>
                                <div className=''>
                                    <label className='field-label self-center'
                                           htmlFor='ignoreProductTypeInDesignName'>Ignore Product Type In Design
                                        Name</label>
                                </div>
                            </div>

                            <div className="field-container w-full justify-start flex mt-8">
                                <input
                                    type="checkbox"
                                    className="h-6 w-6 mr-1"
                                    id="isDefault"
                                    name="isDefault"
                                    value={podDetail?.isDefault}
                                    checked={podDetail?.isDefault}
                                    onChange={handleDetailChanges}>
                                </input>
                                <div className=''>
                                    <label className='field-label self-center'
                                           htmlFor='isDefault'>Is Default</label>
                                </div>
                            </div>

                            {/*<div className="field-container w-full justify-start flex mt-2">
                                <input
                                    type="checkbox"
                                    className="h-6 w-6 mr-1"
                                    id="allowHalfWidthDesign"
                                    name="allowHalfWidthDesign"
                                    value={podDetail?.allowHalfWidthDesign}
                                    checked={podDetail?.allowHalfWidthDesign}
                                    onChange={handleDetailChanges}>
                                </input>
                                <div className=''>
                                    <label className='field-label self-center'
                                           htmlFor='allowHalfWidthDesign'>Allow Half Width Design</label>
                                </div>
                            </div>*/}

                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default EditPodOverview
